import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment } from '@environments';
import { Observable } from 'rxjs';

@Injectable()
export class AddMsvcCredentialsInterceptor implements HttpInterceptor
{
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>>
  {
    if (request.url.includes(Environment.MicroserviceURL))
    {
      return next.handle(request.clone({ withCredentials: true }));
    }

    return next.handle(request);
  }
}
